export default __webpack_public_path__ + "static/media/invoice.9a597806.svg";